import React, { useEffect, useState, useRef, useCallback } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { observer } from 'mobx-react-lite';
import Model from '../../../../model';
import Page from '../../../pages/Page';
import { AudioItem } from 'components/Audio/Item';
import { OtvetAudioPlayer } from 'components/Audio';
import courseLogo from './images/birdy.png';
import './index.sass';

const { cnBlock, el } = bem( 'feelings-course-podcasts' )

const itemName = 'Материалы из курса Вероники «Про чувства»'

const title = itemName;

const FeelingsCoursePodcasts =  () => {

    const { user } = Model;
    const [ activeChapter, setActiveChapter ] = useState( 0 );
    const [ isPlaying, setIsPlaying ] = useState( false );
    const [ showPlayer, setShowPlayer ] = useState( false );
    const [ loading, setLoading ] = useState(false);
    const [ item, setItem ] = useState( null );

    const player = useRef( null );

    useEffect(() => {
        setLoading(true);
        user.getDigital(itemName)
            .then((digital) => {
                setLoading(false);
                if (digital !== undefined) {
                    setItem(digital);
                }
            })
            .catch((error) => {
                setLoading(false)
                console.log(error);
            });
    }, []);

    if (loading) {
        return <Page className={ cnBlock( ) } title={title} loading={loading} />
    }

    if ( !item ) {
        return <Page className={ cnBlock(  ) } title={title} >
            <div className={ el( 'content' ) }>
                <div className={ el('info') }>
                    <Text>{`Курс не был приобретен для пользователя ${user.username}`}</Text>
                </div>
            </div>
        </Page>
    }

    const files = item?.digital?.files.filter(file => !!file.isActive);

    if (files.length === 0) {
        return <Page className={ cnBlock(  ) } title={title} >
            <div className={ el( 'content' ) }>
                <div className={ el('info') }>
                    <Text>{`Курс не содержит материалов`}</Text>
                </div>
            </div>
        </Page>;
    }

    const nextChapterClick = () => {
        if ( activeChapter < files.length - 1 ) {
            setActiveChapter( ( oldChapter ) => oldChapter + 1 )
        }
    }

    const prevChapterClick = () => {
        if ( activeChapter > 0 ) {
            setActiveChapter( ( oldChapter ) => oldChapter - 1 )
        }
    }

    const onChapterClick = ( e ) => ( index ) => {
        if ( index === activeChapter ) {
            player?.current?.togglePlay( e )
        } else {
            setActiveChapter( index );
        }
    }

    const FeelingsAudioItem = ({index, file}) => {
        const handleClick = useCallback((e) => {
            onChapterClick(e)(index);
        }, []);
        return (
            <AudioItem title={file.title} onClick={ handleClick } isPlaying={activeChapter === index && isPlaying} />
        )
    }

    return <Page className={ cnBlock( ) } title={title} >
        <div className={ el( 'content' ) }>
            <div className={ el('top-block')}>
                <div className={ el( 'materials' ) }>
                    { files.map( ( file, index ) =>
                        <FeelingsAudioItem key={index} index={index} file={file} />
                    ) }
                </div>
                <div className={el('right-sidebar')}>
                    <div className={el('image')}>
                        <img src={courseLogo} alt={'Логотип курса'} />
                    </div>
                </div>
            </div>
        </div>
        <div className={ el( 'player', {'hidden': !showPlayer} ) }>
            <OtvetAudioPlayer
                src={ `/media/${ files?.[activeChapter]?.file }` }
                onPlay={ () => {
                    setIsPlaying(true);
                    setShowPlayer(true)
                }}
                onPause={ () => {
                    setIsPlaying(false);
                }}
                onClickPrevious={ prevChapterClick }
                onClickNext={ nextChapterClick }
                ref={player}
            />
        </div>
    </Page>
}

export default observer(FeelingsCoursePodcasts);
